
    <p-table #grid [value]="trades" [lazy]="true" (onLazyLoad)="loadData($event)"
        [loading]="loading" [paginator]="true" [rows]="25" [totalRecords]="totalRecords"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
        [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
        paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
                <th width="100"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-trade>
            <tr (dblclick)="edit(trade)">
                <td>{{trade.name}}</td>
                <td>
                    <div class="flex gap-2 justify-content-end">
                        <p-button *ngIf="allowDelete" (click)="delete(trade)" [rounded]="true"
                            [text]="false" severity="danger">
                            <i class="pi pi-trash"></i>
                        </p-button>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="10">No hay datos</td>
            </tr>
        </ng-template>
    </p-table>
<p-confirmDialog></p-confirmDialog>
